module.exports = __webpack_public_path__ + "static/feature-spatial@2x-4bc84b3bc0cadb4479d340094c9065e0.gif";